import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import TagsPage from 'ext:flarum/tags/forum/components/TagsPage';

/**
 * A vnode whose `attrs` may carry a `className`, as produced by Flarum's
 * component views. Used while walking the rendered `TagsPage` markup.
 */

export default function extendTagOverview() {
  extend(TagsPage.prototype, 'view', function (markup) {
    var _page$tags;
    // `tags` and `loading` are private on TagsPage in 2.x, so reach them
    // through a structural cast.
    const page = this;

    // Pending xhr to load all tags, throw back loading indicator.
    if (page.loading) {
      return markup;
    }
    if (!app.forum.attribute('blogHideTags')) return markup;

    // Get blog tag ID's
    const blogTags = app.forum.attribute('blogTags') || [];
    const tag_tiles_parent = findChild(markup, 'TagsPage-content', true);
    const tag_tiles = getChildren(tag_tiles_parent)[0];
    if (!tag_tiles_parent || !tag_tiles) return markup;
    const tags = (_page$tags = page.tags) != null ? _page$tags : [];

    // Map through the tiles and remove tiles that are part of the blog
    tag_tiles.children = getChildren(tag_tiles).map((tile, i) => {
      var _id, _tags$i;
      return blogTags.indexOf((_id = (_tags$i = tags[i]) == null ? void 0 : _tags$i.id()) != null ? _id : '') >= 0 ? null : tile;
    });
    return markup;
  });
  extend(IndexSidebar.prototype, 'navItems', function (items) {
    if (!app.forum.attribute('blogHideTags')) return;
    const blogTags = app.forum.attribute('blogTags') || [];
    blogTags.forEach(id => {
      items.remove("tag".concat(id));
    });
  });
}
function findChild(parent, childClass, recursive, maxDepth, depth) {
  if (recursive === void 0) {
    recursive = false;
  }
  if (maxDepth === void 0) {
    maxDepth = 50;
  }
  if (depth === void 0) {
    depth = 0;
  }
  const children = getChildren(parent);
  let child = null;
  for (let i = 0; i < children.length; i++) {
    var _vnode$attrs;
    const vnode = children[i];
    const childClassName = (vnode == null || (_vnode$attrs = vnode.attrs) == null ? void 0 : _vnode$attrs.className) || '';
    if (childClassName.includes(childClass)) {
      child = vnode;
      break;
    }
  }

  // Recursive search
  if (recursive && !child && depth < maxDepth) {
    for (const subParent of children) {
      const subChild = findChild(subParent, childClass, true, maxDepth, depth + 1);
      if (subChild) {
        return subChild;
      }
    }
  }
  return child;
}
function getChildren(parent) {
  if (Array.isArray(parent)) {
    return parent;
  }
  const children = parent == null ? void 0 : parent.children;
  if (!Array.isArray(children)) {
    return [];
  }
  return children;
}
flarum.reg.add('fof-blog', 'forum/utils/extendTagOverview', extendTagOverview);